import React from 'react';
import { useFileDropHook } from './fileUploadHook';
import { Typography } from '@material-ui/core';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import useStyles from '../uploadFile/styles';
import { v4 as uuidv4 } from 'uuid';

const FileUploader = (props) => {
  
  const classes = useStyles();

  const {
    handleUpload, text = ''
  } = props;

  const { DropBox, HiddenInput, drag } = useFileDropHook(handleUpload);

  return (
    <div>
      <HiddenInput />
      <DropBox className={drag ? classes.campoOnDragAtivo : classes.campoOnDrag}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <DescriptionOutlinedIcon className={classes.dropIcon} />
          <label className={classes.mainButon} htmlFor="file-uploader" role="button">
            Adicionar arquivo
        </label>
          <input
            style={{ display: 'none' }}
            id="file-uploader"
            type="file"
            multiple
            name={uuidv4()}
            onChange={handleUpload}
          />
        </div>
        <Typography paragraph>ou arraste os arquivos aqui para adiciona-los.</Typography>
        <Typography paragraph>{text}</Typography>
      </DropBox>
    </div>
  )
}

export default FileUploader;
